import React, { Component } from 'react';
import './GuestData.css';
import { connect } from 'react-redux';
import { Input, DatePicker, Button } from 'element-react';
import { updateBookingGuests, getBookingGuests } from '../../services/guests';

class GuestData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guests: [
        {
          name: undefined,
          NIF: undefined,
          dir: undefined,
          birth: null,
        }
      ],
      bookingId: this.props.location.state,
    };
  }

  async componentDidMount() {
    try {
      const { data: { guests } } = await getBookingGuests(this.state.bookingId);
      if (guests) this.setState({ guests });
    } catch (err) {
      console.error(err);
    }
  }

  addGuest() {
    const guests = this.state.guests;
    guests.push({
      name: undefined,
      NIF: undefined,
      dir: undefined,
      birth: null,
    });
    this.setState({ guests });
  }

  deleteGuest(index) {
    const guests = this.state.guests;
    guests.splice(index, 1);
    this.setState({ guests });
  }

  valChange(field, text, index) {
    console.log(text);
    const guests = this.state.guests;
    guests[index][field] = text;
    this.setState({ guests });
  }

  async saveData() {
    await updateBookingGuests(this.state.bookingId, this.state.guests);
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="guestDataWrapper">
        <div className="guestsList">
          {
            this.state.guests.length > 0 && this.state.guests.map((guest, index) => (
              <div key={index} className="guestDetail">
                <div className="headerGuestDetail">
                  <h4>Huésped #{index + 1}</h4>
                  {index > 0 && <i className="el-icon-delete" onClick={() => this.deleteGuest(index)}></i>}
                </div>
                <Input placeholder="Nombre completo" value={guest.name} onChange={(text) => this.valChange('name', text, index)} />
                <Input placeholder="NIF" value={guest.NIF} onChange={(text) => this.valChange('NIF', text, index)} />
                <Input placeholder="Dirección de residencia" value={guest.dir} onChange={(text) => this.valChange('dir', text, index)} />
                <DatePicker
                  firstDayOfWeek="1"
                  value={new Date(guest.birth)}
                  placeholder="Escoge dia"
                  format="dd-MM-yyyy"
                  onChange={date => this.valChange('birth', date, index)}
                  disabledDate={time => time.getTime() > Date.now() - 8.64e7}
                />
              </div>
            ))
          }
        </div>

        {/* <Button onClick={() => this.addGuest()}>Añadir huésped</Button> */}
        <Button onClick={() => this.saveData()}>Guardar datos</Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({ rooms: state.rooms });

export default connect(mapStateToProps)(GuestData);



// WEBPACK FOOTER //
// ./src/components/GuestData/GuestData.js